import { CARA_SESSION_STORAGE_KEY } from './types';
const LOCK_TTL_MS = 20 * 60 * 1000;
const LOCK_TTL_SECONDS = LOCK_TTL_MS / 1000;
const LOCK_HEARTBEAT_MS = LOCK_TTL_MS / 2;
const CARA_COOKIE_REGEXP = new RegExp(`(?:^|;\\s*)${CARA_SESSION_STORAGE_KEY}=([^;]*)`);
const getCookieStore = () => window.cookieStore;
const getParentDomain = () => {
  try {
    const parts = window.location.hostname.split('.');
    return parts.length >= 3 ? `.${parts.slice(1).join('.')}` : '';
  } catch {
    return '';
  }
};
export const createCrossTabLock = _ref => {
  let tabId = _ref.tabId,
    isSessionActive = _ref.isSessionActive,
    onStateChange = _ref.onStateChange;
  const crossSubdomainCookieDomain = getParentDomain();
  let assertionListener = null;
  let heartbeatTimer = null;
  const setCookie = () => {
    if (!crossSubdomainCookieDomain) {
      return;
    }
    document.cookie = `${CARA_SESSION_STORAGE_KEY}=${encodeURIComponent(tabId)}; domain=${crossSubdomainCookieDomain}; path=/; SameSite=Lax; max-age=${LOCK_TTL_SECONDS}`;
  };
  const clearCookie = () => {
    if (!crossSubdomainCookieDomain) {
      return;
    }
    document.cookie = `${CARA_SESSION_STORAGE_KEY}=; domain=${crossSubdomainCookieDomain}; path=/; max-age=0`;
  };
  const getCookieTabId = () => {
    try {
      const match = document.cookie.match(CARA_COOKIE_REGEXP);
      return match ? decodeURIComponent(match[1]) : null;
    } catch {
      return null;
    }
  };
  const startReactiveCookieAssertion = () => {
    const store = getCookieStore();
    if (!store) {
      return;
    }
    assertionListener = _ref2 => {
      let deleted = _ref2.deleted;
      for (const _ref3 of deleted) {
        const name = _ref3.name;
        if (name === CARA_SESSION_STORAGE_KEY && isSessionActive()) {
          setCookie();
          return;
        }
      }
    };
    store.addEventListener('change', assertionListener);
  };
  const stopReactiveCookieAssertion = () => {
    const store = getCookieStore();
    if (store && assertionListener) {
      store.removeEventListener('change', assertionListener);
      assertionListener = null;
    }
  };
  const stopHeartbeat = () => {
    if (heartbeatTimer !== null) {
      clearInterval(heartbeatTimer);
      heartbeatTimer = null;
    }
  };
  const write = () => {
    stopReactiveCookieAssertion();
    try {
      localStorage.setItem(CARA_SESSION_STORAGE_KEY, JSON.stringify({
        tabId,
        expiresAt: Date.now() + LOCK_TTL_MS
      }));
    } catch {}
    setCookie();
    startReactiveCookieAssertion();
    if (heartbeatTimer === null) {
      heartbeatTimer = setInterval(() => {
        if (isSessionActive()) {
          write();
        } else {
          stopHeartbeat();
        }
      }, LOCK_HEARTBEAT_MS);
    }
  };
  const clear = () => {
    stopHeartbeat();
    stopReactiveCookieAssertion();
    try {
      localStorage.removeItem(CARA_SESSION_STORAGE_KEY);
    } catch {}
    clearCookie();
  };
  const check = () => {
    if (isSessionActive()) {
      return;
    }
    try {
      const raw = localStorage.getItem(CARA_SESSION_STORAGE_KEY);
      if (raw !== null) {
        const _ref4 = JSON.parse(raw),
          lockTabId = _ref4.tabId,
          expiresAt = _ref4.expiresAt;
        if (expiresAt && Date.now() > expiresAt) {
          localStorage.removeItem(CARA_SESSION_STORAGE_KEY);
        } else if (lockTabId !== tabId) {
          onStateChange(true);
          return;
        }
      }
    } catch {}
    const cookieTabId = getCookieTabId();
    if (cookieTabId && cookieTabId !== tabId) {
      onStateChange(true);
      return;
    }
    onStateChange(false);
  };
  const handleStorageEvent = event => {
    if (event.key !== CARA_SESSION_STORAGE_KEY) {
      return;
    }
    onStateChange(event.newValue !== null);
  };
  const subscribeToRemoteChanges = () => {
    var _getCookieStore;
    (_getCookieStore = getCookieStore()) == null || _getCookieStore.addEventListener('change', _ref5 => {
      let changed = _ref5.changed,
        deleted = _ref5.deleted;
      const affected = [...changed, ...deleted];
      if (affected.some(_ref6 => {
        let name = _ref6.name;
        return name === CARA_SESSION_STORAGE_KEY;
      })) {
        check();
      }
    });
  };
  return {
    write,
    clear,
    check,
    handleStorageEvent,
    subscribeToRemoteChanges
  };
};
//# sourceMappingURL=caraCrossTabLock.js.map